import { render, staticRenderFns } from "./AddStaffPage.vue?vue&type=template&id=56214303&scoped=true&"
import script from "./AddStaffPage.vue?vue&type=script&lang=js&"
export * from "./AddStaffPage.vue?vue&type=script&lang=js&"
import style0 from "./AddStaffPage.vue?vue&type=style&index=0&id=56214303&prod&lang=scss&scoped=true&"
import style1 from "./AddStaffPage.vue?vue&type=style&index=1&id=56214303&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56214303",
  null
  
)

export default component.exports